import type { SVGProps } from 'react';

const SvgRankLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M13 18.2927C13 18.7043 12.7204 19 12.3435 19C11.9665 19 11.687 18.7043 11.687 18.2927V14.7428H11.4377C11.1762 14.7428 11 14.5239 11 14.2282C11 13.868 11.231 13.733 11.3403 13.6944C11.5167 13.6302 11.6565 13.463 11.7477 13.3214C11.8937 13.0705 12.0942 13 12.4042 13C12.7874 13 13 13.2506 13 13.6108L13 18.2927Z'
      fill='currentColor'
    />
    <path
      d='M18 16C18 17.2429 17.6314 18.3828 16.9972 19.3343C16.0714 20.7057 14.6057 21.6743 12.9 21.9228C12.6086 21.9743 12.3086 22 12 22C11.6914 22 11.3914 21.9743 11.1 21.9228C9.3943 21.6743 7.92858 20.7057 7.00285 19.3343C6.36857 18.3828 6 17.2429 6 16C6 12.6829 8.68286 10 12 10C15.3171 10 18 12.6829 18 16Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M5 7V3.57009C5 3.25654 5.25603 3 5.56895 3H18.4311C18.744 3 19 3.25654 19 3.57009V7'
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeLinecap='round'
    />
    <path d='M9 3V8' stroke='currentColor' strokeMiterlimit={10} strokeLinecap='round' />
    <path d='M15 3V8' stroke='currentColor' strokeMiterlimit={10} strokeLinecap='round' />
    <path d='M5 7L12 9L19 7' stroke='currentColor' strokeLinejoin='round' />
  </svg>
);
export default SvgRankLt;
